<template>
  <div class="smy__card-full-box">
      <div class="table" style="margin:17px 0">
          <Table
            stripe
            ref="table"
            :loading="listLoading"
            :columns="columns"
            :data="updataList"
          />
      </div>
      <PicsModal
        :pics="picList"
        :visible="picModel"
        :index="picIndex"
        @on-close="picModel = false"
      />
  </div>
</template>

<script>
import {mapState} from 'vuex'

import PicsModal from '@/components/PicsModal'

export default {
  components: {
    PicsModal
  },
  props: {
    accountList: {
      type: Object,
      required: true
    },
    updataList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      urlImg: '',
      picModel: false,
      picList: [],
      picIndex: 0,
      pageIndex: 0,
      listLoading: false
    }
  },
  computed: {
    ...mapState('table', [
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '付款凭证图片',
          width: 140,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let check = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.picIndex = this.index
                  this.picModel = true
                  this.urlImg = row.img_urls
                  this.showPicList(row.id)
                }
              }
            }, ['查看'])
            return h('span', [check])
          }
        },
        {
          title: '操作时间',
          key: 'create_time',
          width: 180
        },
        {
          title: '操作',
          width: 140,
          render: (h, {row}) => {
            let priority = row.agent_level
            let priorityName = ''
            if (priority === 1) {
              priorityName = '升级铜牌'
            } else if (priority === 2) {
              priorityName = '升级银牌'
            } else {
              priorityName = '升级金牌'
            }
            return h('span', [priorityName])
          }
        },
        {
          title: '缴纳保证金',
          key: 'price',
          width: 140
        },
        {
          title: '流水单号',
          key: 'flow_no',
          width: 140
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  methods: {
    showPicList (index) {
      let arrImg = this.urlImg
      let arr = arrImg.split(',')
      console.log(arr)
      if (arr.length !== 0) {
        arr.forEach((item) => {
          this.picList.push(item)
        })
      }
      this.picIndex = index
      this.picModel = true
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = (pageIndex - 1)
      this.loadList()
    }
  }
}
</script>

<style lang="less" scoped>
.accountRemant{
  display: flex;
  .left{
    width: 300px;
    flex-shrink: 0;
  }
  .right{
    width: 100%;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/agentManage/agencyManage/AgencyManageRight.vue